export default {
    methods: {
        objectKeysToCamelCase(obj) {
            const camelObj = {}
            Object.keys(obj).forEach(key => {
                const parsed = key.replace(/([-_][a-z])/g, group =>
                    group
                        .toUpperCase()
                        .replace('-', '')
                        .replace('_', '')
                )
                camelObj[parsed] = obj[key]
            })
            return camelObj
        },
    },
}
